// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media only screen and (min-width:1264px){.oao-pi-flyin .v-content{padding-right:342px!important}}", ""]);
// Exports
module.exports = exports;
